// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './styles/common.css'
import './styles/changeStyle.css'
import "babel-polyfill";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './icons/iconfont/iconfont.css'
import './icons/iconfont/iconfont.js'
import animate from 'animate.css'
Vue.use(animate)
Vue.use(ElementUI)
import myAxios from './commonJs/myAxios.js' //封装的axios插件
Vue.use(myAxios)
import common from './commonJs/common.js' //封装的axios插件
Vue.use(common)
Vue.config.productionTip = false;

new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js